import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../i18n/constants/keys';

interface CollapsibleProps {
  title: string;
  children: ReactNode;
  isOpen: boolean;
  toggleOpen: () => void;
  headerActions?: ReactNode;
}

const Collapsible = ({
  title,
  children,
  isOpen,
  toggleOpen,
  headerActions,
}: CollapsibleProps) => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <div className='bg-white rounded-lg border border-gray-200 overflow-hidden transition-all duration-200 shadow-sm'>
      <div
          onClick={toggleOpen}
          className='w-full flex items-center justify-between px-3 py-2.5 cursor-pointer transition-colors duration-150 hover:bg-gray-50 focus:outline-none'
      >
        <div className='flex items-center gap-2'>
          <div
              className={`w-6 h-6 rounded flex items-center justify-center transition-all duration-200 ${
                isOpen ? 'bg-emerald-500 text-white' : 'bg-gray-100 text-gray-500'
              }`}
          >
            <svg
                xmlns='http://www.w3.org/2000/svg'
                className={`w-4 h-4 transform transition-transform duration-200 ${
                  isOpen ? 'rotate-180' : ''
                }`}
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={2.5}
            >
              <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M19 9l-7 7-7-7'
              />
            </svg>
          </div>
          <h3 className='text-sm font-semibold text-gray-900'>{ title }</h3>
        </div>
        <div className='flex items-center gap-4'>
          { headerActions && (
            <div onClick={(e) => e.stopPropagation()}>{ headerActions }</div>
          ) }
          <span className='text-xs text-gray-400'>
            { isOpen
              ? t(ADMIN_PAGES_KEYS.jobOpenings.ui.clickToCollapse)
              : t(ADMIN_PAGES_KEYS.jobOpenings.ui.clickToExpand) }
          </span>
        </div>
      </div>
      <div
          className={`overflow-hidden transition-all duration-200 ${
            isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
          }`}
      >
        <div className='px-3 py-3 bg-gray-50/30 border-t border-gray-100'>
          { children }
        </div>
      </div>
    </div>
  );
};

export default Collapsible;
